import { MessagePlugin } from 'tdesign-vue-next'
import { ref } from 'vue'
import { tasksEvent, isNullValue } from '../utils/'

import useRequest from './useRequest'
/**
 * @description: 评价列表
 **/
export default (emit) => {
  const { getEvaluateCountRequest, putEvaluateSubmitRequest, getEvaluateTreeRequest } = useRequest()
  const treeData = ref([])
  const count = ref(0)
  const targetItem = ref(null)
  const submitLoading = ref(false)
  const evaluateRef = ref(null)
  const otherItem = ref(null)
  const commentData = ref([])
  const projectId = ref('')
  /**
   * 初始化数据
   */
  const initData = async (item = null) => {
    if (isNullValue(item)) return
    commentData.value = []
    otherItem.value = item
    count.value = 0
    targetItem.value = null
    projectId.value = item.projectId
    const res = await getEvaluateTreeRequest(item.projectId)
    if (res && res?.tree.length) {
      treeData.value = tasksEvent(res.tree[0].children, null)
    }
  }

  /**
   * 关闭弹窗
   */
  const closeEvent = () => {
    treeData.value = []
    count.value = 0
    targetItem.value = null
    submitLoading.value = false
    otherItem.value = null
  }
  /**
   * 数量赋值
   * @param {*} count
   * @evaType 0:个人 1: 群组
   */
  const checkTargetEvent = (target, evaType = null) => {
    if (isNullValue(evaType) || isNullValue(target)) return
    targetItem.value = { ...target, projectId: projectId.value }
    getEvaluateCountReuqset(target.targetId, evaType)
    const { targetVo } = target
    if (!isNullValue(targetVo.preSetComments)) {
      const comments = targetVo.preSetComments.split('\n').filter((item) => !isNullValue(item))
      commentData.value = comments.map((item, index) => {
        return { content: item, id: index }
      })
    } else {
      commentData.value = []
    }
  }

  /**
   * 获取指标被评价次数
   */
  const getEvaluateCountReuqset = async (targetId, evaType) => {
    const { userId, groupId } = otherItem.value
    const objectId = userId || groupId
    if (isNullValue(objectId)) return
    const params = {
      targetId,
      type: ['PERSONAL', 'GROUP', 'PERSONAL', 'PERSONAL'][evaType],
      objectId,
    }

    const result = await getEvaluateCountRequest(params)
    count.value = result || 0
  }
  /**
   * 学生提交
   */
  const studentSubmitEvent = async (list = [], classInfo = {}) => {
    if (isNullValue(list)) {
      MessagePlugin.error('请选择被评价对象！')
      return false
    }
    let projectId = null
    const { classId, className } = classInfo
    const objects = list.map((item) => {
      if (isNullValue(projectId)) projectId = item.projectId
      return {
        typeOfEvaluateObject: 'PERSON',
        evaluateObjectId: item.userId,
        evaluateObjectName: item.userName,
        scopeOfLaunchId: classId,
        scopeOfLaunchName: className,
      }
    })
    const tempParams = getRequestParams(targetItem.value, evaluateRef.value)
    if (isString(tempParams)) {
      MessagePlugin.error(tempParams)
      return false
    }
    submitLoading.value = true
    const params = {
      projectId,
      ...tempParams,
      objects,
      classGroupId: null,
      classGroupName: null,
    }
    try {
      await putEvaluateSubmitRequest(params)
      refreshEvent()
      return true
    } catch (error) {
      MessagePlugin.error(error.message)
    } finally {
      submitLoading.value = false
    }
  }
  /**
   * 获取上传的参数
   */
  const getRequestParams = (targetItem, evaluate) => {
    if (isNullValue(targetItem)) return '请先选择评价指标'
    const { activeType, comment } = evaluate
    if (isNullValue(activeType)) return '请选择类型'
    const { targetId, name: targetName, targetVo, secondNodeId, secondNodeName } = targetItem
    const { recordMode, recordModeSetting } = targetVo
    if (recordMode !== 'GRADE') return '指标类型不为等级'
    const { grades } = JSON.parse(recordModeSetting) || {}
    if (isNullValue(grades)) return '指标类型等级参数为空'
    const gradesItems = grades.filter((item) => item.name === activeType)
    if (gradesItems.length === 0) return '等级没有对应的使用项'
    const recordResult = gradesItems[0]?.level || null
    if (isNullValue(recordResult)) return '等级没有level属性'
    const evidence = evaluate.evidence.length ? JSON.stringify(evaluate.evidence) : null
    return {
      comment,
      targetId,
      evidence,
      recordMode,
      targetName,
      secondNodeId,
      recordResult,
      secondNodeName,
    }
  }

  /**
   * 刷新
   */
  const refreshEvent = () => {
    submitLoading.value = false
    MessagePlugin.success('评价成功！')
    closeEvent()
    emit('refresh')
  }
  /**
   * 判断是否字符串
   */
  const isString = (value) => {
    return typeof value === 'string' || value instanceof String
  }
  return {
    count,
    treeData,
    initData,
    closeEvent,
    targetItem,
    evaluateRef,
    commentData,
    submitLoading,
    checkTargetEvent,
    studentSubmitEvent,
  }
}
